// import { ObjectStore } from '@store/objectStore';
import { TaskStore } from '@store/taskStore';
import { OrderStore } from './orderStore';
import { CurrentUserStore } from "@store/currentUserStore";
import { OrderStatusStore } from '@store/orderStatusStore';
import { NavigationStore } from '@store/navigationStore';
import { OrderAdminPanelStore } from '@organisms/orders/orderProfile/components/orderAdminPanel/store';

export class RootStore {
    readonly orderStore = new OrderStore();
    // readonly objectStore = new ObjectStore();
    readonly currentUserStore = new CurrentUserStore();
    readonly taskStore = new TaskStore();
    readonly orderStatusStore = new OrderStatusStore();
    readonly navigationStore = new NavigationStore();
    readonly orderAdminPanelStore = new OrderAdminPanelStore();
}
